import { APP_INITIALIZER, NgModule } from '@angular/core';
// import { OAuthModule } from 'angular-oauth2-oidc';
import { LOCATION } from '../location';
import { AuthService } from './auth.service';

@NgModule({
  // imports: [OAuthModule.forRoot()],
  providers: [
    AuthService,
    {
      provide: LOCATION,
      useValue: window.location
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthService) => () => authService.initAuth(),
      deps: [AuthService],
      multi: true
    }
  ]
})
export class AuthModule {}
